import React from "react";
import Navigation from "./components/layout/Navigation";
import HeroSection from "./components/layout/HeroSection";
import AboutSection from "./components/layout/AboutSection";
import WhyRwanda from "./components/layout/WhyRwanda";
import Footer from "./components/layout/Footer";
import BuzzwordCards from "./components/interactive/BuzzwordCards";
import ContactInfoComponent from "./components/interactive/ContactInfoComponent";
import { ResponsiveProvider } from "./contexts/ResponsiveContext";
import layoutStyles from "./styles/layout.module.css";
import BootstrapWrapper from "./components/BootstrapWrapper";
import { BrowserRouter } from "react-router-dom";

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <ResponsiveProvider>
        <BootstrapWrapper>
          <Navigation />
          <main className={layoutStyles.mainContent}>
            <HeroSection
              title="We build platforms that your team can own, not dependencies they can't escape"
              subtitle="Knowledge transfer is built into every engagement. Our goal is your independence."
              imageSrc="/kigalihagen.jpg"
            />
            <AboutSection />
            <WhyRwanda />
            <section id="services" className={layoutStyles.testimonialSection}>
              <BuzzwordCards />
            </section>
          </main>
          <section id="contact">
            <ContactInfoComponent />
          </section>
        </BootstrapWrapper>
        <Footer />
      </ResponsiveProvider>
    </BrowserRouter>
  );
};

export default App;
